import { useState } from 'react';

import { ChartData } from '@/types';

const useSelectedCharts = () => {
  const [selectedCharts, setSelectedCharts] = useState<ChartData[]>([]);

  return { selectedCharts, setSelectedCharts };
};

export default useSelectedCharts;
